import Actions from '../../odata/actions';

const actions = new Actions('rateSchedule', 'rateSchedules');

export default actions;
